// extracted by mini-css-extract-plugin
export default {"content":"PL-z","lookName":"QL-z","shopTheLookContainer":"RL-z","productContainer":"SL-z","imageContainer":"TL-z","mainImage":"UL-z"};